module.exports = __webpack_public_path__ + "static/media/Edit.891d2075.svg";